<div class="view-container">
  @if (view() === 'upload') {
  <div class="drop-section">
    <app-dashed-content
      data-test-id="users-invite-dialog-dashed-content"
      [highlight]="isDraggingFilesOverDropZone()"
      (dragenter)="onDragEnter($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <input
        type="file"
        #fileInput
        (change)="handleSelectFile($event)"
        class="hidden-input"
        multiple
      />
      <div class="icon-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-cloud-upload-icon lucide-cloud-upload"
        >
          <path d="M12 13v8" />
          <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
          <path d="m8 17 4-4 4 4" />
        </svg>
      </div>
      <app-text
        [size]="TextSize.BODY_2"
        [height]="TextHeight.MEDIUM"
        [color]="TextColor.NEUTRAL_8"
        [weight]="TextWeight.MEDIUM"
        [align]="TextAlign.CENTER"
        [spacingBottom]="Spacing.X_SMALL"
        >{{ 'eligibilityFile.actionText' | translate }}</app-text
      >
      <app-text
        [size]="TextSize.BODY_1"
        [height]="TextHeight.MEDIUM"
        [color]="TextColor.NEUTRAL_6"
        [weight]="TextWeight.REGULAR"
        [align]="TextAlign.CENTER"
        [spacingBottom]="Spacing.X_SMALL"
        >{{ 'eligibilityFile.actionSubText' | translate }}</app-text
      >
      @if (isDraggingFilesOverDropZone()) {
      <div class="dragging-overlay">
        <p class="dragging-overlay-text">
          Drop {{ draggingNumOfFiles() }} files(s)
        </p>
      </div>
      }
    </app-dashed-content>
  </div>
  @if (showDroppedFilesSection()) {
  <app-view
    [direction]="ViewDirection.COLUMN"
    [spacingBottom]="Spacing.X_LARGE"
  >
    @if (getTotalUploadedMessage()) {
    <div class="dialog-list-top">
      <p class="dialog-list-top-text">{{ getTotalUploadedMessage() }}</p>
    </div>
    }
    <div class="dialog-list-wrapper">
      <ul class="dialog-list">
        @for(file of eligibilityFilesImportService.processedFiles(); track
        file.name) {
        <li>
          @if (isFileValid(file)) {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2806_499)">
              <path
                d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
                fill="#14E25A"
              />
            </g>
            <defs>
              <clipPath id="clip0_2806_499">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          } @else {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#F5BCC5"
            />
          </svg>
          }
          <app-text
            [size]="TextSize.BODY_1"
            [height]="TextHeight.SMALL"
            [weight]="TextWeight.BOLD"
            >{{ file.name }}</app-text
          >
          <div>
            <app-text
              [size]="TextSize.BODY_1"
              [height]="TextHeight.SMALL"
              [weight]="TextWeight.REGULAR"
              >{{ getFileMessage(file) }}
            </app-text>
          </div>
        </li>
        }
      </ul>
    </div>
    @if (getTotalParsedMessage()) {
    <div class="dialog-list-bottom">
      <p class="dialog-list-bottom-text">Total {{ getTotalParsedMessage() }}</p>
    </div>
    }
  </app-view>
  }
  <app-view
    [direction]="ViewDirection.ROW"
    [align]="ViewAlign.CENTER"
    [justify]="ViewJustify.CENTER"
    [gap]="Spacing.MEDIUM"
  >
    <button
      class="destructive-button"
      [disabled]="submitDisabled()"
      (click)="handleDeleteUsers()"
      data-test-id="eligibility-file-delete-users-button"
    >
      Remove Users
    </button>
    <app-button
      [type]="ButtonType.PRIMARY"
      [disabled]="submitDisabled()"
      (handleClick)="handlePrepareInvites()"
      [spacingBottom]="Spacing.NONE"
      [size]="ButtonSize.SMALL"
      data-test-id="eligibility-file-dialog-submit-button"
      >Send Invites</app-button
    >
  </app-view>
  } @else if (view() === 'process') {
  <app-view
    [direction]="ViewDirection.COLUMN"
    [spacingBottom]="Spacing.X_LARGE"
  >
    <div class="dialog-list-wrapper">
      <ul class="dialog-list">
        @for(batch of batches(); track batch.batchId) {
        <li>
          @if (getBatchStatusIcon(batch.status) === 'success') {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2806_600)">
              <path
                d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
                fill="#14E25A"
              />
            </g>
            <defs>
              <clipPath id="clip0_2806_600">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          } @else if (getBatchStatusIcon(batch.status) === 'error') {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#F5BCC5"
            />
          </svg>
          } @else if (getBatchStatusIcon(batch.status) === 'warning') {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#FFA500"
            />
          </svg>
          } @else {
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="8" stroke="#6d7073" stroke-width="2" />
            <circle cx="10" cy="10" r="4" fill="#6d7073" />
          </svg>
          }
          <app-text
            [size]="TextSize.BODY_1"
            [height]="TextHeight.SMALL"
            [weight]="TextWeight.BOLD"
            >Batch {{ batch.batchId }}</app-text
          >
          <div>
            <app-text
              [size]="TextSize.BODY_1"
              [height]="TextHeight.SMALL"
              [weight]="TextWeight.REGULAR"
              >{{ getBatchStatusText(batch) }}
            </app-text>
          </div>
        </li>
        }
      </ul>
    </div>
  </app-view>
  <app-view
    [direction]="ViewDirection.ROW"
    [align]="ViewAlign.CENTER"
    [justify]="ViewJustify.CENTER"
  >
    @if (isRemovalPreviewMode() && !isProcessing() && !allBatchesComplete()) {
    <button
      class="destructive-button"
      (click)="handleContinueWithRemoval()"
      data-test-id="eligibility-file-continue-removal-button"
    >
      Confirm Removal (can't be undone)
    </button>
    } @else {
    <app-button
      [type]="ButtonType.PRIMARY"
      (handleClick)="handleViewResults()"
      [disabled]="!allBatchesComplete()"
      [size]="ButtonSize.SMALL"
      [spacingBottom]="Spacing.NONE"
      data-test-id="eligibility-file-view-results-button"
      >View Results</app-button
    >
    }
  </app-view>
  } @else if (view() === 'invites') {
  <app-view
    [direction]="ViewDirection.COLUMN"
    [spacingBottom]="Spacing.X_LARGE"
    [gap]="Spacing.SMALL"
  >
    @if (successfulEmails().length > 0) {
    <app-text
      [size]="TextSize.TITLE_2"
      [height]="TextHeight.TITLE_1"
      [color]="TextColor.NEUTRAL_8"
      [weight]="TextWeight.BOLD"
      >{{ successfulEmails().length }}
      {{
        eligibilityFilesImportService.operationMode() === 'remove'
          ? 'user(s) removed'
          : 'invite(s) succeeded'
      }}</app-text
    >
    } @if (failedEmails().length > 0) {
    <app-text
      [size]="TextSize.TITLE_2"
      [height]="TextHeight.TITLE_1"
      [color]="TextColor.NEUTRAL_8"
      [weight]="TextWeight.BOLD"
      >{{ failedEmails().length }}
      {{
        eligibilityFilesImportService.operationMode() === 'remove'
          ? 'removal(s) failed'
          : 'invite(s) failed'
      }}</app-text
    >
    } @if (unprocessedEmails().length > 0) {
    <app-text
      [size]="TextSize.TITLE_2"
      [height]="TextHeight.TITLE_1"
      [color]="TextColor.NEUTRAL_8"
      [weight]="TextWeight.BOLD"
      >{{ unprocessedEmails().length }}
      {{
        eligibilityFilesImportService.operationMode() === 'remove'
          ? 'user(s) not processed'
          : 'invite(s) not processed'
      }}</app-text
    >
    }
  </app-view>
  <app-view
    [direction]="ViewDirection.COLUMN"
    [spacingBottom]="Spacing.X_LARGE"
  >
    <div class="dialog-list-wrapper">
      <ul class="dialog-list" data-test-id="eligibility-file-invites-list">
        @for(result of allInviteResults(); track result.email) {
        <li data-test-id="eligibility-file-invite-list-item">
          @if (result.status === InviteUserResultStatus.SUCCESS) {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-test-id="eligibility-file-icon-success"
          >
            <g clip-path="url(#clip0_2806_800)">
              <path
                d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
                fill="#14E25A"
              />
            </g>
            <defs>
              <clipPath id="clip0_2806_800">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          } @else if (result.status === InviteUserResultStatus.FAIL) {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-test-id="eligibility-file-icon-fail"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#F5BCC5"
            />
          </svg>
          } @else {
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="8" stroke="#6d7073" stroke-width="2" />
            <circle cx="10" cy="10" r="4" fill="#6d7073" />
          </svg>
          }
          <app-text
            [size]="TextSize.BODY_1"
            [height]="TextHeight.SMALL"
            [weight]="TextWeight.BOLD"
            >{{ result.email }}</app-text
          >
          <div>
            <app-text
              [size]="TextSize.BODY_1"
              [height]="TextHeight.SMALL"
              [weight]="TextWeight.REGULAR"
              >{{
                result.message ||
                  (result.status === InviteUserResultStatus.SUCCESS
                    ? eligibilityFilesImportService.operationMode() === 'remove'
                      ? 'Successfully removed'
                      : 'Successfully invited'
                    : eligibilityFilesImportService.operationMode() === 'remove'
                    ? 'Failed to remove'
                    : 'Failed to invite')
              }}
            </app-text>
          </div>
        </li>
        }
      </ul>
    </div>
  </app-view>
  <app-view
    [direction]="ViewDirection.ROW"
    [align]="ViewAlign.CENTER"
    [justify]="ViewJustify.END"
    [gap]="Spacing.MEDIUM"
  >
    @if (eligibilityFilesImportService.emailsForCSVExport().length > 0) {
    <button
      class="secondary-button"
      (click)="handleDownloadFailedEmails()"
      data-test-id="eligibility-file-download-failed-button"
    >
      Download Unsuccessful
      {{
        eligibilityFilesImportService.operationMode() === 'remove'
          ? 'Removals'
          : 'Invites'
      }}
    </button>
    }
    <app-button
      [type]="ButtonType.PRIMARY"
      (handleClick)="handleDone()"
      [size]="ButtonSize.SMALL"
      data-test-id="eligibility-file-done-button"
      [spacingBottom]="Spacing.NONE"
      >Done</app-button
    >
  </app-view>
  }
</div>
